// this file is generated by update_shopify_store_data.py at 2026-01-26 20:20:15.600646
var courses = [
    {
        "course_id": "C1623BB7-56A6-ED11-80FE-005056B135DF",
        "course_version": 9,
        "name": "ART Essentials",
        "course_type": 1,
        "author_information": "The content from this activity was originally written by a team of writers, subject matter experts, and clinicians from HealthStream. The planning committee has reviewed this updated content and determined it to be appropriate for inclusion in this activity.",
        "description": "The ART Program was developed to increase patient safety, improve all aspects of critical care and resuscitation, and reduce the likelihood of premature death. This program will improve your understanding of human physiology and enhance your clinical judgment.\r\n\r\nART: Essentials comprises three Sections:\r\n\r\nSection 1: Becoming an ARTist is designed to provide you with a foundational understanding of The ART Program and its approach to preventable death, which we will build upon over four modules.\r\n\r\nSection 2: Physiology of Deterioration introduces you to the Integrated Model of Physiology, which is the conceptual framework that provides an understanding of the physiology that underlies deterioration. We will build upon this conceptual framework over four modules.\r\n\r\nSection 3: ART in Action examines the Final Four Pathways to deterioration using the ART principles and evaluate each of the Fatal Fifteen clinical conditions using the C-STAR methodology.\r\n\r\nEach Section includes one case scenario allowing you an opportunity to apply your learning in a customized case study environment. You will be presented with a patient to care for and will determine the physiologic pathway your patient may deteriorate from, then you will Anticipate, Recognize, and Target while applying the C-STAR mnemonic to ultimately prevent or reverse deterioration.\r\n\r\nPlease note: Completing this learning activity does not authorize you to add any skill discussed in the content to your practice if this function is not included in your current scope of practice.",
        "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Identify physiologic patterns of deterioration using the ART wheel.</li>\r\n    <li>Associate diagnostic and therapeutic strategies to prevent or reverse deterioration.</li>\r\n    <li>Connect the Final Four Pathways and Fatal Fifteen clinical conditions to the physiological processes of perfusion and respiration.</li>\r\n    <li>Examine the causes of each of the Final Four pathway arrests.</li>\r\n    <li>Apply common and etiology-specific therapies for the Fatal Fifteen\u202fclinical conditions.</li>\r\n</ul>\r\n<p><strong>Activity Planners and Authors</strong></p>\r\n<ul>\r\n    <li>Daniel Davis, MD (Author, Content Expert)</li>\r\n    <li>David Laumeyer, BSN, RN, CCRN, CFRN (Nurse Planner)</li>\r\n    <li>Emmanouil Kiriakopolous, DO (Course Director)</li>\r\n    <li>Amanda Pitt, MBA, BSN, RN, RN-BC (Nurse Planner)</li>\r\n    <li>Evan McEwing, DNP, PHNA-BC, RN, CCRP, CHSE, Director, Content Development and Research, HealthStream (AP-PD)</li>\r\n    <li><span>Jessi</span><span>ca Ellis, RN, BSN, Director, Cont</span><span>ent Development, </span>HealthStream (Content Reviewer)</li>\r\n    <li>Germaine Broussard, B.S., Sr. Development Manager, HealthStream (Content Reviewer)</li>\r\n    <li>CorShun Thurman, B.A., Accreditation Specialist, HealthStream</li>\r\n    <li>Melissa Pickens, BBA, Accreditation Specialist, HealthStream</li>\r\n</ul>\r\n<p>None of the planners for this educational activity have relevant financial relationship(s) to disclose with ineligible companies whose primary business is producing, marketing, selling, re-selling, or distributing healthcare products used by or on patients.</p>\r\n<p><strong>Commercial Support</strong></p>\r\n<p>This activity was not commercially supported.</p>\r\n<p><strong>Criteria for Completion </strong></p>\r\n<p>This activity contains a post-test and reflective/interactive content. You must complete the entire activity, including the evaluation, and score an 80% or higher on the post-test in order to obtain a certificate of completion. Partial credit will not be given.</p>\r\n<p>Licensees must provide their license/member numbers for record keeping purposes. Continuing education licensing/certification requirements vary by profession and state. Learners should contact their licensing/certification board or professional organization to confirm that these contact hours will be accepted. HealthStream does not warrant acceptance.</p>\r\n<p><strong>CE Release &amp; Expiration Dates</strong></p>\r\n<p><strong>ANCC (Registered Nurses)</strong></p>\r\n<p>Release Date: 12/23/2024</p>\r\n<p>Expiration Date: 12/22/2027&nbsp;</p>\r\n<p><strong>ACCME (Medical Providers)</strong></p>\r\n<p>Release Date: 12/23/2024</p>\r\n<p>Expiration Date: 12/22/2027</p>\r\n<p><strong>Content Review:</strong></p>\r\n<p>All HealthStream accredited content is continuously reviewed to ensure alignment with current standards of care.</p>",
        "course_outline_html": "<ul>\r\n    <li>Section1: Becoming an ARTist\r\n    <ul>\r\n        <li>Module 1.1: Introduction to The ART Program</li>\r\n        <li>Module 1.2: Anticipate</li>\r\n        <li>Module 1.3: Recognize</li>\r\n        <li>Module 1.4: Target</li>\r\n        <li>Module 1.5: ART Case Scenario 1</li>\r\n    </ul>\r\n    </li>\r\n    <li>Section 2: Physiology of Deterioration\r\n    <ul>\r\n        <li>Module 2.1: Fundamentals of Physiology Using C-STAR</li>\r\n        <li>Module 2.2: Perfusion Deterioration\u202f\u202f</li>\r\n        <li>Module 2.3: Oxygenation Deterioration</li>\r\n        <li>Module 2.4: Ventilation Deterioration\u202f\u202f</li>\r\n        <li>Module 2.5: ART Case Scenario 2\u202f\u202f\u202f\u202f\u202f</li>\r\n    </ul>\r\n    </li>\r\n    <li>Section 3: ART in Action\r\n    <ul>\r\n        <li>Module 3.1: Circulatory Pathway Deterioration</li>\r\n        <li>Module 3.2: Dysthymic Pathway Deterioration</li>\r\n        <li>Module 3.3: Respiratory Pathway Deterioration</li>\r\n        <li>Module 3.4: Neurologic Pathway Deterioration</li>\r\n        <li>Module 3.5: ART Case Scenario 3</li>\r\n    </ul>\r\n    </li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "82A50AA9-9182-E211-B22E-0015171C1A75",
                "course_category_name": "Renal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                "course_category_name": "Infectious Diseases",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D6D72E5-07DB-E511-AA9E-005056B17E48",
                "course_category_name": "Neurological Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5F33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncologic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E543B79-437D-F011-999C-005056A7C0C7",
                "course_category_name": "Clinical ED Continuing Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                "course_category_name": "Cardiac Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7EC24674-C3A7-ED11-80FC-005056B160AF",
                "course_category_name": "Medical X Technologies - ART Essentials",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                "course_category_name": "Online CE",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8ABF6591-B4D6-F011-99A7-005056A725AD",
                "course_category_name": "ART Essentials",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "Diagnostic Tests & Examinations",
                "is_system_course_category": null
            },
            {
                "course_category_id": "60D42284-B4D6-F011-99A7-005056A725AD",
                "course_category_name": "ART Essentials",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Rehabilitation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "281B0C70-437D-F011-999C-005056A7C0C7",
                "course_category_name": "ED Pathway Complete",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C5E0945D-F18B-EF11-9996-005056A77B46",
                "course_category_name": "z_ContentOps \u2013 Standard Evaluation Update",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A0AB3C64-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Military Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7F34B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Urinary Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Endocrine Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8279C63B-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Primary Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                "course_category_name": "Geriatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A34B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Respiratory Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F2FD20B1-37E5-11DD-8683-001517135351",
                "course_category_name": "Multisystem Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                "course_category_name": "Online CME",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5F62DFF0-A2B3-ED11-8100-005056B142B5",
                "course_category_name": "Medical X Technologies",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Critical Care Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-000000001090",
                "course_category_name": "Airway Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "14A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Family Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F66135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Administrators",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BD6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Managers",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DB33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Laboratory Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Geriatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FB1CBC9E-25C9-E511-8771-005056B104B1",
                "course_category_name": "Infection",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                "course_category_name": "Gerontology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiac Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D68C685B-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Pulmonology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "58382785-93D1-E511-BF53-005056B122EA",
                "course_category_name": "Respiratory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C2068A6B-F3FD-E611-BC44-005056B10E33",
                "course_category_name": "Diabetic Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                "course_category_name": "Injuries",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DCDC98B2-C3A7-ED11-80FC-005056B160AF",
                "course_category_name": "HSTM - ART",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A67AA68A-25C9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Hematologic & Lymphatic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "311E9BEF-23C9-E511-8771-005056B104B1",
                "course_category_name": "Community Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6063707-5F83-F011-999D-005056A726F7",
                "course_category_name": "ED Pathway Complete [Manage Publishing with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "235953F6-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neurosurgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Vascular Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "35F57D8C-437D-F011-999C-005056A7C0C7",
                "course_category_name": "Clinical Deterioration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30824C37-B2F3-EB11-80E4-005056B134EC",
                "course_category_name": "ansrsource",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E32CF83-389F-11DD-AD08-0015171C1B93",
                "course_category_name": "Neurological & Neurocognitive Disorders",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ACCME; ANCC",
            "accreditation_statement": "<p><span style=\"font-size: 11pt; font-family: calibri, sans-serif;\">For licensed professionals who use CE Broker: HealthStream will automatically report your completion to CE Broker if your licensing board is listed. You must enter your license number, state, and discipline in your HealthStream profile for successful reporting. Other professionals may self-report the completion, if appropriate. </span></p>\r\n<p><img width=\"136\" height=\"115\" style=\"width: 136px; height: 115px;\" alt=\"HealthStream Reports to CE Broker within 24hrs\" src=\"https://www.healthstream.com/content/_CEBroker/CEBrokerReportsBadge-24Hrs.png\" /></p>",
            "course_level_accreditation_statement": "<p style=\"text-align: center;\"><strong>Physicians</strong><br />\r\nHealthStream, Inc. is accredited by the Accreditation Council for Continuing Medical Education (ACCME) to provide continuing medical education for physicians.<br />\r\n<br />\r\n</p>\r\n<p style=\"text-align: center;\">HealthStream, Inc. designates this enduring material for a maximum of 4.0 AMA PRA Category 1 Credit(s)&trade;. Physicians should claim only the credit commensurate with the extent of their participation in the activity.<br />\r\n<br />\r\n<strong>Other Healthcare Providers</strong><br />\r\nThis activity was awarded AMA PRA Category 1 Credit(s)&trade;.</p>\r\n<p style=\"text-align: center;\"><strong>State Boards of Medicine</strong></p>\r\n<p style=\"text-align: center;\">Florida Board of Medicine</p>\r\n<p style=\"text-align: center;\">Florida Physicians Assistants</p>\r\n<p style=\"text-align: center;\">Texas Board of Medicine</p>\r\n<p style=\"text-align: center;\"><strong>Nurses</strong></p>\r\n<p style=\"text-align: center;\">HealthStream CNE Provider Unit is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation. ANCC Provider Number: P0088</p>\r\n<p style=\"text-align: center;\">This activity is awarded 4.0 contact hour(s); 0 contact hours are in the area of pharmacology.</p>\r\n<p style=\"text-align: center;\"><strong>State Nursing Boards</strong></p>\r\n<p style=\"text-align: center;\">Arkansas State Board of Nursing</p>\r\n<p style=\"text-align: center;\">District of Columbia Board of Nursing</p>\r\n<p style=\"text-align: center;\">Florida Board of Nursing</p>\r\n<p style=\"text-align: center;\">Georgia Board of Nursing</p>\r\n<p style=\"text-align: center;\">Michigan Board of Nursing</p>\r\n<p style=\"text-align: center;\">New Mexico Board of Nursing</p>\r\n<p style=\"text-align: center;\">North Dakota Board of Nursing</p>\r\n<p style=\"text-align: center;\">South Carolina Board of Nursing</p>\r\n<p style=\"text-align: center;\"><em>CE Broker Tracking Number: 50-907</em></p>\r\n<p style=\"text-align: center;\">Course Number: [CourseIdentifier]&nbsp;<em>Category: </em>General</p>\r\n<p style=\"text-align: center;\">*<em>Please note: Some boards will round the reported contact hours to the nearest 0.5 hour.</em></p>",
            "credit_display_name": "ACCME; ANCC",
            "credit_units": 4.0,
            "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
        },
        "sub_courses": []
    }
];